import { useEffect, useState } from "react";
import { CloseOutlined, CheckSquareOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import Status from "../components/preview/status";
import RejectModal from "../components/preview/rejectModal";
import { normalizeMongolianPhone } from "../utils/functions";
import PreviewRoot from "../components/PreviewRoot";
import DateTime from "../components/DateTime";
import axios from "../utils/axios";
import { getStore } from "../utils/global";
import custom from "../utils/custom";
import Loading from "../components/Loading";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";

const PreviewRoute = ({ params }) => {
  const { pop, popfilter, txin_id } = params;
  const user = getStore("user");
  const colors = getStore("color");
  const getTxin = getStore("txin");
  const provider = custom.getCookie("provider");
  const [visible, setVisible] = useState(false);
  const [page, setPage] = useState(1);
  const queryClient = useQueryClient();
  const history = useHistory();

  const make_box = (per) => {
    let box = document.createElement("div");
    let inside = document.createElement("div");
    box.style.height = per?.boxheight + "px";
    box.style.width = per?.boxwidth + "px";
    box.style.background = per?.bg_color;
    box.style.border = "1px solid " + per?.bg_color;
    box.style.left = per?.x1 + "px";
    box.style.bottom = per?.y1 + "px";
    box.style.position = "absolute";
    box.className = "drop_box";
    inside.className = "drop_box_name";
    inside.style.width = per?.boxwidth + "px";
    inside.style.overflowWrap = "break-word";
    inside.innerHTML = per?.value || per?.type;
    if (per?.type?.includes("Text")) {
      box.style.textAlign = "left";
      box.style.alignItems = "start";
    }
    box.appendChild(inside);
    if (per?.type === "signature") {
      inside.innerHTML = "Digital Signature";
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per?.footer;
      box.appendChild(inside_name);
    } else if (per?.type === "yourSignature") {
      inside.innerHTML = "Signature";
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per?.footer;
      box.appendChild(inside_name);
    } else if (per?.type === "yourStamp") {
      inside.innerHTML = "Stamp";
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per?.footer;
      box.appendChild(inside_name);
    } else if (per?.type === "yourInitials") {
      inside.innerHTML = "Initials";
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per?.footer;
      box.appendChild(inside_name);
    }

    return box;
  };

  const close = () => {
    history.goBack();
  };

  const doc_reject = () => {
    setVisible(true);
  };

  const { mutate: doc_sign, isLoading: signLoading } = useMutation({
    mutationKey: ["doc_sign"],
    mutationFn: (id) => axios.post("client/api/doc/sign", { docid: id, provider }, { showSuccessMessage: true, showErrorMessage: true }),
    onSuccess: ({ success }) => {
      if (success) {
        setTimeout(() => {
          queryClient.refetchQueries({ queryKey: ["get_user_doc_count"] });
          queryClient.refetchQueries({ queryKey: ["get_doc_list"] });
          queryClient.invalidateQueries({ queryKey: ["get_file_data"] });
          queryClient.invalidateQueries({ queryKey: ["get_doc_data"] });
          history.push("/home");
        }, 2000);
      }
    },
  });

  const { mutate: doc_approve, isLoading: approveLoading } = useMutation({
    mutationKey: ["doc_approve"],
    mutationFn: (id) => axios.post("client/api/doc/approve", { docid: id }, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.refetchQueries({ queryKey: ["get_user_doc_count"] });
        queryClient.refetchQueries({ queryKey: ["get_doc_list"] });
        queryClient.invalidateQueries({ queryKey: ["get_file_data"] });
        queryClient.invalidateQueries({ queryKey: ["get_doc_data"] });
        history.push("/home");
      }
    },
  });

  const renderTools = () => {
    let coords = [];
    let container = document.querySelector(".document_watermark_container");
    if (!container) return;
    let droppable = document.createElement("div");
    droppable.className = "document_watermark_container_dropable";
    container.innerHTML = "";
    container.appendChild(droppable);
    docInfo?.parts.forEach((per, i) => {
      per?.coords.forEach((per1, i1) => {
        per1.part_index = i;
        per1.coords_index = i1;
        per1.bg_color = per?.bg_color;
        per1.footer = per?.name || per?.msisdn || per?.email || per?.footer;
        coords.push(per1);
      });
    });

    coords.forEach((per) => {
      if (page === per?.page) {
        let box = make_box(per);
        container.appendChild(box);
      }
    });
  };

  const { data: docInfo, isLoading } = useQuery({
    queryKey: ["get_doc_data", getTxin, txin_id, popfilter],
    queryFn: () => axios.post("/client/api/doc/get/new", { docid: popfilter, txnid: txin_id || getTxin }, { showErrorMessage: true }),
    enabled: pop === "preview",
    staleTime: false,
    select: ({ data, success }) => {
      if (success) {
        let { kdss_detail, kdss_status } = data;
        kdss_detail?.participants?.forEach((per, i) => {
          per.key = per?.key_c;
          per.bg_color = colors[i];
          per.coords = [];
          kdss_detail?.signatures &&
            kdss_detail?.signatures.forEach((per1, i1) => {
              if (normalizeMongolianPhone(per1.msisdn) === normalizeMongolianPhone(per?.msisdn)) {
                per.coords.push(per1);
              }
            });
          kdss_detail?.fields &&
            kdss_detail?.fields.forEach((per1, i1) => {
              if (normalizeMongolianPhone(per1.msisdn) === normalizeMongolianPhone(per?.msisdn)) {
                per.coords.push(per1);
              }
            });
        });

        let tmp = kdss_status?.signers;
        let first = tmp[data?.kdss_status?.signerindex - 1];
        let actionType = "wait";

        if (kdss_detail?.status === "COMPLETE") {
          actionType = "complete";
        } else {
          if (first.userid === user.kdss_user) {
            actionType = first.actionrole;
          } else {
            actionType = "wait";
          }
        }
        const tempParts = kdss_detail?.participants.sort((a, b) => (a.order >= b.order ? 1 : -1));
        return { kdss_detail, kdss_status, parts: tempParts, actionType };
      }
    },
  });

  const { data: file, isLoading: fileLoading } = useQuery({
    queryKey: ["get_file_data", getTxin, txin_id, popfilter],
    queryFn: () =>
      axios.post(
        "/client/api/doc/file/get",
        {
          docid: popfilter,
          complete: docInfo?.kdss_detail.status === "ARCHIVED" || docInfo?.kdss_detail.status === "COMPLETE",
        },
        { showErrorMessage: true },
      ),
    select: ({ data }) => custom.base64tou8(data),
    staleTime: false,
    enabled: pop === "preview" && !!docInfo?.kdss_detail.status,
  });

  const renderButtons = (id) => {
    if (docInfo?.kdss_detail?.status === "WAITING")
      switch (docInfo?.actionType) {
        case "signer":
          return (
            <>
              <button
                className="btn"
                bg_color="5"
                onClick={() => {
                  doc_sign(id);
                }}>
                sign
              </button>
              <button className="btn" bg_color="6" onClick={() => setVisible(true)}>
                reject
              </button>
            </>
          );
        case "approver":
          return (
            <>
              <button
                className="btn"
                bg_color="5"
                onClick={() => {
                  doc_approve(id);
                }}>
                approve
              </button>
              <button className="btn" bg_color="6" onClick={() => setVisible(true)}>
                reject
              </button>
            </>
          );
        case "copy":
          return (
            <div className="preview_reminder">
              <InfoCircleOutlined />
              You have no permission to sign , approve or reject this document.
            </div>
          );
        case "complete":
          return;
        default:
          return (
            <div className="preview_reminder">
              <InfoCircleOutlined />
              Please wait other members.
            </div>
          );
      }
  };

  const renderTitle = (i) => {
    let active = docInfo?.kdss_status?.signers[i];
    if (active?.status === "waiting") return active?.actionrole;
    else if (active?.status === "rejected") {
      let rejectedUser = docInfo?.kdss_detail?.rejected_by;
      return active?.msisdn === rejectedUser.msisdn ? "Rejected" : active?.status;
    } else {
      switch (active?.actionrole) {
        case "approver":
          return "Approved";
        case "signer":
          return "Signed";
        default:
          return active?.actionrole;
      }
    }
  };

  useEffect(() => {
    renderTools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const renderViewer = () => {
    return docInfo?.kdss_detail?.status === "ARCHIVED" || docInfo?.kdss_detail?.status === "COMPLETE" ? (
      <embed
        type="application/pdf"
        src={URL.createObjectURL(
          new Blob([file], {
            type: "application/pdf",
          }),
        )}
        width="100%"
        height="100%"
      />
    ) : (
      <PreviewRoot
        parts={docInfo?.parts}
        stamps={[]}
        senderx={{
          name: docInfo?.kdss_status?.sender?.name,
          msi: docInfo?.kdss_status?.sender?.msisdn,
          email: docInfo?.kdss_status?.sender?.email,
        }}
        file={file}
        funcs={{ doc_reject, doc_sign, doc_approve }}
        docs={docInfo?.kdss_detail}
        actiontype={docInfo?.actionType}
        rendertitle={renderTitle}
        pageChange={setPage}
        onSuccess={() => {
          let element = document.createElement("div");
          let dropable = document.createElement("div");
          dropable.className = "document_watermark_container_dropable";
          element.className = "document_watermark_container";
          element.appendChild(dropable);
          document.querySelector(".react-pdf__Page").appendChild(element);
          renderTools();
        }}
      />
    );
  };

  return (
    <div>
      <div className="preview_container" is_show={pop === "preview" ? 1 : 0}>
        {pop === "preview" && (
          <>
            <Loading loading={isLoading || fileLoading || approveLoading || signLoading} />
            <div className="preview_header" bg_color="2">
              <div className="upload_header_close flex_center" onClick={close} color="3">
                <CloseOutlined />
              </div>
              <span className="doc_info_title">
                <span>
                  Doc preview: <b> {docInfo?.kdss_detail?.name} </b>
                </span>
                <span className="doc_info_date">
                  <DateTime value={docInfo?.kdss_detail?.created_dt} />
                </span>
              </span>
            </div>
            <div className="step1_container" style={{ flex: 1 }}>
              <div className="step1_detail">
                <div className="step1_detail_status">
                  <span style={{ opacity: "0.7" }}>Status:</span>
                  <Status status={docInfo?.kdss_detail?.status} />
                  {docInfo?.kdss_status?.rejectreason && (
                    <div
                      style={{
                        marginTop: 15,
                        maxHeight: "150px",
                        padding: 5,
                        overflow: "auto",
                        backgroundColor: "#F2F2F2",
                      }}>
                      Rejected reason : {docInfo?.kdss_status.rejectreason}
                    </div>
                  )}
                </div>
                <div className="step1_actions">{renderButtons(docInfo?.kdss_detail?.docid)}</div>
                <div className="step1_user_detail" style={{ marginTop: 20 }}>
                  <div className="step1_user_detail_title">
                    Sender
                    {docInfo?.kdss_detail?.status === "CANCELLED" && <div className="cancelled">cancelled</div>}
                  </div>
                  <div className="step1_user_detail_body">
                    <div className="user_dropdown_name">{docInfo?.kdss_status?.sender?.name}</div>
                    <div className="user_dropdown_mobile">{docInfo?.kdss_status?.sender?.msisdn}</div>
                    <div className="user_dropdown_email" color="1">
                      {docInfo?.kdss_status?.sender?.email}
                    </div>
                    {docInfo?.kdss_status?.cancelreason && docInfo?.status === "CANCELLED" && (
                      <>
                        <Divider style={{ color: "rgb(223, 22, 22)" }} plain orientation="left">
                          Cancelled reason:
                        </Divider>
                        <div className="preview_reminder">
                          <InfoCircleOutlined />
                          {docInfo?.kdss_status?.cancelreason}
                        </div>
                      </>
                    )}
                  </div>
                  {docInfo?.kdss_detail?.status === "CANCELLED" && (
                    <div
                      style={{
                        justifyContent: "flex-end",
                        padding: "0 5px",
                        fontSize: "11px",
                        opacity: "0.7",
                        display: "flex",
                      }}>
                      <span style={{ marginRight: "3px" }}>Cancelled on </span> <DateTime value={docInfo?.kdss_detail?.modified_dt} />
                    </div>
                  )}
                </div>
                <div className="parts_scroll_area">
                  {docInfo?.parts?.map((per, i) => {
                    return (
                      <div
                        key={i}
                        className="step1_user_detail"
                        style={{
                          marginTop: 20,
                          opacity: docInfo?.kdss_status?.signerindex - 1 === i ? "1" : "0.6",
                        }}
                        issigned={docInfo?.kdss_status?.signerindex - 1 === i ? "1" : "0"}>
                        <div
                          className="step1_user_detail_title"
                          style={{
                            background: per?.bg_color,
                            textTransform: "capitalize",
                          }}>
                          {renderTitle(i)}
                          {docInfo?.kdss_status?.signers[docInfo?.kdss_status?.signerindex - 1]?.order < per?.order && (
                            <span className="preview_waiting">Waiting</span>
                          )}
                          <div className="step1_user_signed">
                            <CheckSquareOutlined />
                          </div>
                        </div>
                        <div className="step1_user_detail_body">
                          <div className="user_dropdown_name">{per?.name}</div>
                          <div className="user_dropdown_mobile">{per?.msisdn}</div>
                          <div className="user_dropdown_email" color="1">
                            {per?.email}
                          </div>
                        </div>
                        {docInfo?.kdss_status?.signers[i]?.signingtime && (
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              fontSize: "11px",
                              padding: "0 3px",
                            }}>
                            <DateTime value={docInfo?.kdss_status?.signers[i]?.signingtime} />
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="step3_body">
                <div className="absfull">{file && renderViewer()} </div>
              </div>
            </div>
          </>
        )}
      </div>
      <RejectModal onCancel={() => setVisible(false)} visible={visible} docid={docInfo?.kdss_detail?.docid} />
    </div>
  );
};

export default PreviewRoute;
